import ApiConfig from '../config/api'
import BaseAction from './action.abstract'

export default class MachineAction extends BaseAction {
  fetchMachineInfo(machineId: any): Promise<any> {
    return this.FetchSimpleData(ApiConfig.api.machine.machine_info, {
      machine_id: machineId,
    })
  }

  publishMachine(machineId: any, action: string): Promise<any> {
    return this.CallRequest(ApiConfig.api.machine.machine_publish, 'put', {
      machine_id: machineId, action,
    })
  }

  editMachineAttribute(machineId: any, formData: any): Promise<any> {
    return this.CallRequest(ApiConfig.api.machine.attribute_edit, 'post', {
      machine_id: machineId, ...formData,
    })
  }

  createMachine(formData: any): Promise<any> {
    return this.CallRequest(ApiConfig.api.machine.machine_create, 'post', formData)
  }

  editMachine(machineId: any, formData: any): Promise<any> {
    return this.CallRequest(ApiConfig.api.machine.machine_edit, 'post', {
      machine_id: machineId, ...formData,
    })
  }
}

export const machineAction = new MachineAction()
